// L'allineamento automatico delle tabelle, mentre scrivi.
//
// La regola: si allinea la tabella che NON stai scrivendo. Riscrivere le
// colonne mentre hai il cursore dentro sposterebbe il testo sotto le dita a
// ogni carattere — l'ho tenuto legato alla composizione per questo, ma «alla
// composizione» non è «automaticamente»: la forma giusta è allinearla appena
// il cursore la lascia.

import { Transaction, type Extension } from "@codemirror/state";
import { EditorView } from "@codemirror/view";

import { blocchiTabella } from "./tabelle";


function allinea(view: EditorView): void
{
    const stato = view.state;
    const rigaCursore = stato.doc.lineAt(stato.selection.main.head).number - 1;
    const cambi: { from: number; to: number; insert: string }[] = [];

    for (const blocco of blocchiTabella(stato.doc.toString()))
    {
        // Quella sotto il cursore si lascia stare: è quella che stai scrivendo.
        if (rigaCursore >= blocco.daRiga && rigaCursore < blocco.aRiga) { continue; }

        const da = stato.doc.line(blocco.daRiga + 1).from;
        const a = stato.doc.line(blocco.aRiga).to;

        if (stato.sliceDoc(da, a) !== blocco.testo) { cambi.push({ from: da, to: a, insert: blocco.testo }); }
    }

    if (cambi.length === 0) { return; }

    view.dispatch({
        changes: cambi,
        scrollIntoView: false,
        // Fuori dalla storia: annullare deve riportare al TUO testo, non a un
        // passaggio di formattazione che non hai chiesto.
        annotations: Transaction.addToHistory.of(false),
        userEvent: "format.tabelle",
    });
}


export function tabelleAutomatiche(): Extension
{
    return EditorView.updateListener.of((u) =>
    {
        if (!u.docChanged && !u.selectionSet) { return; }

        // Non si dispatcha dentro il ciclo di aggiornamento: si aspetta il
        // fotogramma dopo, quando lo stato è posato.
        requestAnimationFrame(() => allinea(u.view));
    });
}
